import React from 'react'
import { useSelector } from 'react-redux'
import formatNumber from '../helpers/formatNumber'

const WatchListPage = () => {
  const watchLists = useSelector(state => state.watchLists)
  return (
    <>
      <div className="container mt-3 text-center">
        <h1>Watch List</h1>
        <table className="table table-striped table-info mt-4">
          <thead>
            <tr>
              <th scope="col">Provinsi</th>
              <th scope="col">Kasus Aktif</th>
              <th scope="col">Kasus Positif</th>
              <th scope="col">Kasus Sembuh</th>
              <th scope="col">Kasus Meninggal</th>
            </tr>
          </thead>
          <tbody>
            {watchLists.map((watchList) => (
            <tr key={watchList.fid}>
              <td>{watchList.provinsi}</td>
              <td>{formatNumber(watchList.kasusPosi - (watchList.kasusMeni + watchList.kasusSemb))}</td>              
              <td>{formatNumber(watchList.kasusPosi)}</td>              
              <td>{formatNumber(watchList.kasusSemb)}</td>
              <td>{formatNumber(watchList.kasusMeni)}</td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>
    </>
  )
}

export default WatchListPage